export enum PagesTypes {
  News = 'news',
  Default = 'default',
  Doctor = 'doctor',
  Webinar = 'webinar',
}
